var openPayScript
export default {
  methods: {
    loadOpenPayScript(publicKey, success = () => { }) {
      // console.log(publicKey)
      if (!openPayScript) {
        openPayScript = window.document.createElement('script')
        openPayScript.src = 'https://resources.openpay.mx/lib/openpay-js/1.2.38/openpay.v1.min.js'
        openPayScript.onload = () => {
          OpenPay.setId('mu5zmsiucs1fupd9kuhs');
          OpenPay.setApiKey('pk_c23b3f6fa2514103a164d3dfee2b7bde');
          OpenPay.setSandboxMode(true);
          console.log('OpenPay已加载成功')
          success && success()
        }
        var head = window.document.head || window.document.getElementsByTagName('head')[0] || window.document.documentElement
        head.insertBefore(openPayScript, head.firstChild)
      } else {
        console.log('OpenPay已加载')
        success && success()
      }
    }
  }
}
